import React from "react";
import { Link } from "react-router-dom";
import { House } from "@phosphor-icons/react";

// Persistent "back to Field Hub" affordance — only shown once a worker is
// identified on this device, so field pages always have a route home.
export default function FieldHomeLink({ variant = "dark", className = "" }) {
  let hasWorker = false;
  try { hasWorker = !!JSON.parse(localStorage.getItem("eq_field_worker") || "null"); } catch { hasWorker = false; }
  if (!hasWorker) return null;
  const tone = variant === "dark"
    ? "text-gray-300 hover:text-white"
    : "text-gray-500 hover:text-equipr-black";
  return (
    <Link to="/field" data-testid="field-home-link"
      className={`inline-flex items-center gap-1 text-[13px] font-semibold ${tone} ${className}`}>
      <House size={16} weight="bold" /> Home
    </Link>
  );
}
